import React from 'react';
import './LearnDIY.css';

const LearnDIY: React.FC = () => {
  const topics = [
    {
      icon: '🛢️',
      title: 'Oil Changes',
      description: 'Learn when to change your oil, what type to use, and how to do it safely in your driveway.'
    },
    {
      icon: '🛞',
      title: 'Tire Care',
      description: 'Master tire rotations, pressure checks, and how to change a flat with confidence.'
    },
    {
      icon: '🔋',
      title: 'Battery & Electrical',
      description: 'Understand jumpstarts, battery replacement, and basic electrical troubleshooting.'
    },
    {
      icon: '🛑',
      title: 'Brakes & Fluids',
      description: 'Check brake pads, top off fluids, and learn the warning signs before small issues become big ones.'
    },
    {
      icon: '🔧',
      title: 'Common Repairs',
      description: 'Step-by-step guides for air filters, wiper blades, belts, and other everyday maintenance.'
    },
    {
      icon: '👨‍🏫',
      title: 'Learn from Locals',
      description: 'Connect with experienced community members who can teach you hands-on in person or walk you through it.'
    }
  ];

  return (
    <section id="learn-diy" className="learn-diy">
      <div className="learn-diy-container">
        <div className="learn-diy-header">
          <h2 className="learn-diy-title">Learn to Fix Your Own Car</h2>
          <p className="learn-diy-subtitle">
            GetStrandX isn't just for emergencies — it's where you learn real car skills.
            From oil changes to basic repairs, build confidence with guided tutorials and help from people in your community.
          </p>
        </div>

        <div className="learn-diy-grid">
          {topics.map((topic, index) => (
            <div key={index} className="learn-diy-card">
              <div className="learn-diy-icon">{topic.icon}</div>
              <h3 className="learn-diy-card-title">{topic.title}</h3>
              <p className="learn-diy-card-description">{topic.description}</p>
            </div>
          ))}
        </div>

        <div className="learn-diy-cta">
          <p>Whether you're stuck on the side of the road or want to stop paying for every oil change — we've got you covered.</p>
          <button
            className="learn-diy-btn"
            onClick={() => document.getElementById('prelaunch-survey')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Join the Waitlist
          </button>
        </div>
      </div>
    </section>
  );
};

export default LearnDIY;
